import {getAuthenticatedThemisClient, RevenueCategoryView} from '@modifi/onboarding-api-clients'
import {EntityFactory} from '@modifi/redux'

import {AppThunkAction} from '../../types/redux'

const apiClient = getAuthenticatedThemisClient()

const {actions, reducer, selectors} = EntityFactory({
  actionNamePrefix: 'data/revenueCategories',
  reducerPath: ['data', 'revenueCategories'],
  fetchRequest: () =>
    apiClient?.StaticData?.fetchRevenueCategories().then(
      res => res.data()?.revenueCategories || []
    ),
})

export default reducer

export const selectRevenueCategoryConfig = (state: Record<string, any>): RevenueCategoryView[] =>
  (selectors.selectEntity(state) || []) as unknown as RevenueCategoryView[]

const aFetchRevenueCategories = (): AppThunkAction => actions.fetch()

export const aEnsureFetchRevenueCategories =
  (): AppThunkAction<void> =>
  (dispatch, getState): void => {
    const RevenueCategoryConfig = selectRevenueCategoryConfig(getState())
    if (!RevenueCategoryConfig?.length) {
      dispatch(aFetchRevenueCategories())
    }
  }
